import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlusIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.0007 8.66659H8.66732V11.9999C8.66732 12.3666 8.36732 12.6666 8.00065 12.6666C7.63398 12.6666 7.33398 12.3666 7.33398 11.9999V8.66659H4.00065C3.63398 8.66659 3.33398 8.36659 3.33398 7.99992C3.33398 7.63325 3.63398 7.33325 4.00065 7.33325H7.33398V3.99992C7.33398 3.63325 7.63398 3.33325 8.00065 3.33325C8.36732 3.33325 8.66732 3.63325 8.66732 3.99992V7.33325H12.0007C12.3673 7.33325 12.6673 7.63325 12.6673 7.99992C12.6673 8.36659 12.3673 8.66659 12.0007 8.66659Z",
		fill: "CurrentColor"
	})
});
export default SvgPlusIcon;
